import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';

import { UtilService } from 'src/app/services/util.service';
import { cameraList } from '../../models/camera.model';

import { NgSelectModule } from '@ng-select/ng-select';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { Sites } from '../../models/history.model';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-manage-client-sites',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgClass, NgSelectModule],
  templateUrl: './manage-client-sites.component.html',
  styleUrl: './manage-client-sites.component.scss'
})
export class ManageClientSitesComponent {

  private modalService = inject(BsModalService);
  private fb = inject(UntypedFormBuilder);
  private _utils = inject(UtilService);
  private siteService = inject(SiteService);

  allCameraList: cameraList[] = [];
  addSubscription: Subscription;
  clientSites!: UntypedFormGroup;
  getAllCameraList: Subscription;
  getAllSiteList: Subscription;
  allSite: Sites[] = [];
  isLoading: boolean = false;

  constructor() {
    this.clientSites = this.fb.group({
      name: ['', [Validators.required]],
      sites: [],
    });
  }

  ngOnInit(): void {
    this.getFilterList();
    const allAssignSites = UtilService.allClientSiteDataWithClientData;
    if (allAssignSites) {
      if (allAssignSites.sites && allAssignSites.sites.length > 0) {
        allAssignSites.sites = allAssignSites.sites.map((site) => site._id);
      }
      this.clientSites.patchValue({
        name: `${allAssignSites.first_name} ${allAssignSites.last_name}`,
        sites: allAssignSites.sites ? allAssignSites.sites : [],
      });
    }
  }

  getFilterList() {
    this.getAllSiteList = this.siteService.getAllSites().subscribe({
      next: (res) => {
        if (res) {
          this.allSite = res;
        } else {
          this._utils.showErrorInfo('Something wrong!');
        }
      },
      error: (e) => console.log(e),
      complete: () => this.getAllSiteList.unsubscribe()
    });
  }

  closeModal() {
    this.modalService.hide();
  }

  manageAddUpdateClientSites() {
    this._utils.markFormGroupDirty(this.clientSites);
    if (this.clientSites.valid) {
      this.isLoading = true;
      const params = {
        clientId: UtilService.allClientSiteDataWithClientData._id,
        siteIds: this.clientSites.value.sites
      }
      console.log("params ::>>", params)
      this.addSubscription = this.siteService.manageAddUpdateClientSites(params).subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res) {
            this.clientSites.reset();
            this.closeModal();
            this._utils.showErrorSuccess('Client sites manage successfully');
          } else {
            this._utils.showErrorInfo('Something wrong!');
          }
        },
        error: (e) => { this.isLoading = false; console.log(e) },
        complete: () => this.addSubscription.unsubscribe()
      });
    }
  }

  ngOnDestroy(): void {
    if (this.addSubscription) this.addSubscription.unsubscribe();
    if (this.getAllCameraList) this.getAllCameraList.unsubscribe();
    if (this.getAllSiteList) this.getAllSiteList.unsubscribe();
  }
}
